const actionScope = '[Legal Terms Archive]';

export class LoadLegalTermsArchiveIfNotLoaded {
  static readonly type = `${actionScope} Load Legal Terms Archive If Not Loaded`;
}

export class LoadLegalTermsArchive {
  static readonly type = `${actionScope} Load Legal Terms Archive`;
}

export class DownloadArtifact {
  static readonly type = `${actionScope} Download Artifact By Id`;

  constructor(
    public id: string,
    public filename: string
  ) {}
}
